/* eslint-disable max-len */
import React, { FC, useEffect, useState } from 'react'
import Modal from '../common/Modal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import DateCalendarModule from './DateCalendarModule'
import { nowDate } from '../../../utils/date'

interface Props {
  closeCallback: VoidFunction
  updateCallback: (date: string, keyword: string) => void
  searchData: {date: string, keyword: string}
  isDisplay: boolean
}

const GanttSearchModal: FC<Props> = (props) => {
  const {
    closeCallback,
    updateCallback,
    searchData,
    isDisplay,
  } = props

  const [searchDate, setSearchDate] = useState<string>("")
  const [searchKeyword, setSearchKeyword] = useState<string>("")

  const [isInputSchedule, setIsInputSchedule] = useState<boolean>(false)

  const closeModal = () => {
    closeCallback()
  }

  const submit = () => {
    updateCallback(searchDate, searchKeyword)
  }

  useEffect(() => {
    setSearchDate(isDisplay ? searchData.date : "")
    setSearchKeyword(isDisplay ? searchData.keyword : "")
    setIsInputSchedule(isDisplay && !!searchData.date)
  }, [isDisplay])

  useEffect(() => {
    setSearchDate(isInputSchedule ? nowDate() : "")
  }, [isInputSchedule])

  return (
    <Modal
      show={isDisplay}
      wrapperClass="gantt_modal w900"
      closeCallback={closeModal}
      closeable
    >
      <>
        <div
          style={{
            fontSize: "14px",
            fontWeight: "bold",
            padding: "4px 8px",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            marginBottom: "16px",
            color: "#666666",
          }}
        >
          絞り込み
        </div>
        <fieldset>
          <legend>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              対象日
              <FontAwesomeIcon
                icon={['fas', isInputSchedule ? 'toggle-on' : 'toggle-off']}
                onClick={() => setIsInputSchedule(!isInputSchedule)}
                style={{
                  color: isInputSchedule ? "#0b9554" : "#999999",
                  fontSize: "20px",
                }}
              />
            </div>
          </legend>
          <div className="item w50" style={{ marginBottom: "0" }}>
            <div className="detail equal_space row_1" style={{ position: "relative" }}>
              {
                isInputSchedule ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "14px",
                      }}
                    >
                      予定期間に
                    </div>
                    <DateCalendarModule
                      date={searchDate || nowDate("YYYY-MM-DD")}
                      changeCallback={(callback_date) => {
                        setSearchDate(callback_date)
                      }}
                      disabled={false}
                      future
                      omit
                    />
                    <div
                      style={{
                        fontSize: "14px",
                      }}
                    >
                      を含む
                    </div>
                  </div>
                ) : (
                  <div
                    onClick={() => setIsInputSchedule(true)}
                    role="none"
                    style={{
                      fontSize: "14px",
                      color: "#999999",
                    }}
                  >
                    対象日指定なし
                  </div>
                )
              }
            </div>
          </div>
        </fieldset>
        <fieldset>
          <legend>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              キーワード
            </div>
          </legend>
          <div className="item w100" style={{ marginBottom: "0" }}>
            <div className="detail row_1" style={{ display: "flex", alignItems: "center", gap: "4px" }}>
              <input
                type="text"
                placeholder="キーワード指定なし"
                onChange={(event) => setSearchKeyword(event.target.value)}
                value={searchKeyword}
              />
            </div>
          </div>
        </fieldset>
        <div className="button_area">
          <button
            type="button"
            className="button cancel"
            onClick={() => closeCallback()}
          >
            キャンセル
          </button>
          <button
            type="button"
            className="button"
            onClick={submit}
          >
            絞り込む
          </button>
        </div>
      </>
    </Modal>
  )
}

GanttSearchModal.defaultProps = {
}

export default GanttSearchModal
